import React from 'react'

const NotFound = props => {
    return <h1>Page not found</h1>
}

export default NotFound